module.exports = __webpack_public_path__ + "static/media/rhino.c51d3ea3.png";